import React from 'react';

import { Dialog } from '../Dialog/Dialog';
import Button from '../Button/Button';

function ConfirmationDialog({ bodyText, onSubmit, onCancel, submitLabel, cancelLabel, open, nonCancellable, warning }) {
  const actions = [
    !nonCancellable && (
      <Button color="secondary" key="cancel-btn" onClick={onCancel}>
        {cancelLabel}
      </Button>
    ),
    <Button key="submit-btn" color="primary" onClick={onSubmit}>
      {submitLabel}
    </Button>,
  ];

  return (
    <Dialog actions={actions} modal open={open} fullWidth>
      <div className="confirmation-dialog-text">{bodyText}</div>
      {warning && <div className="confirmation-dialog-warning">{warning}</div>}
    </Dialog>
  );
}

export default ConfirmationDialog;
